import { useBemCN } from '@gik/core/utils/bemBlock';
import withComponentErrorBoundary from '@gik/core/utils/withComponentErrorBoundary';
import { WishlistRows } from '@gik/wishlist-page/components/WishlistRows';
import { WishlistSidebarSection } from '@gik/wishlist-page/components/WishlistSidebarSection';
import React from 'react';

interface IWishlistSectionProps {
  inkindRouteId: string;
}

function WishlistSectionComp({ inkindRouteId }: IWishlistSectionProps) {
  const bem = useBemCN('wishlist-section');

  return (
    <WishlistSidebarSection inkindRouteId={inkindRouteId} {...bem(null)}>
      <WishlistRows inkindRouteId={inkindRouteId} />
    </WishlistSidebarSection>
  );
}

export const WishlistSection = withComponentErrorBoundary(WishlistSectionComp);
